<template>
  <div>
    <rejected-orders-table
      :loading="loading"
      :rejected-orders="orders"
      @updateList="fetchRejectOrder"
    />
  </div>
</template>

<script>
import rejectedOrdersTable from '../../components/orders/rejected-orders-table.vue';
import api from '@/api/axios';
export default {
  name: 'RejectedOrders',
  components: { rejectedOrdersTable },
  data() {
    return {
      orders: [],
      loading: false,
    };
  },
  created() {
    this.fetchRejectOrder();
  },
  methods: {
    async fetchRejectOrder() {
      try {
        this.loading = true;
        await api
          .get('/admin/order-reject-requests', {
            params: {
              all: 1,
            },
          })
          .then((res) => {
            this.orders = res.data.data;
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
        return error;
      }
    },
  },
};
</script>